export default theme => ({
  flex: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(10),
  },
});
